(function () {
  'use strict';

  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }

    return '$' + (cents / 100).toFixed(2);
  }

  function setText(element, text) {
    if (element && element.textContent !== text) element.textContent = text;
  }

  function setAttribute(element, name, value) {
    if (element.getAttribute(name) !== value) element.setAttribute(name, value);
  }

  function initProduct(product) {
    if (product.dataset.dwPdpCroReady === 'true') return;
    product.dataset.dwPdpCroReady = 'true';

    var gallery = product.querySelector('[data-product-photos]');
    var counter = product.querySelector('[data-dw-gallery-count]');
    var currentCount = product.querySelector('[data-dw-gallery-current]');
    var galleryPrevious = product.querySelector('[data-dw-gallery-prev]');
    var galleryNext = product.querySelector('[data-dw-gallery-next]');
    var mainButton = product.querySelector('[data-add-to-cart]');
    var mainButtonText = product.querySelector('[data-add-to-cart-text]');
    var sticky = product.querySelector('[data-dw-pdp-sticky]');
    var stickyButton = product.querySelector('[data-dw-sticky-button]');
    var stickyButtonText = product.querySelector('[data-dw-sticky-button-text]');
    var stickyPrice = product.querySelector('[data-dw-sticky-price]');
    var stickyPriceWrap = product.querySelector('[data-dw-sticky-price-wrap]');
    var stickyCompareRow = product.querySelector('[data-dw-sticky-compare-row]');
    var stickyCompare = product.querySelector('[data-dw-sticky-compare]');
    var stickyLabel = product.querySelector('[data-dw-sticky-label]');
    var mainButtonVisible = false;

    function updateGalleryCounter() {
      if (!gallery || !counter || !currentCount) return;
      var selected = gallery.querySelector('.product-main-slide.is-selected') ||
        gallery.querySelector('.product-main-slide:first-child');
      if (!selected) return;
      setText(currentCount, String(Number(selected.dataset.index || 0) + 1));
    }

    function moveGallery(direction) {
      var thumbnails = Array.prototype.slice.call(
        product.querySelectorAll('.product__thumb-item:not(.hide) [data-product-thumb]')
      );
      if (thumbnails.length < 2) return;

      var activeIndex = thumbnails.findIndex(function (thumbnail) {
        return thumbnail.classList.contains('is-active');
      });
      if (activeIndex < 0) activeIndex = 0;

      var nextIndex = (activeIndex + direction + thumbnails.length) % thumbnails.length;
      thumbnails[nextIndex].click();
    }

    function syncStickyButton() {
      if (!mainButton || !stickyButton || !stickyButtonText) return;
      setText(stickyButtonText, mainButtonText ? mainButtonText.textContent.trim() : 'Add to cart');
      stickyButton.classList.toggle('is-disabled', mainButton.disabled);
      setAttribute(stickyButton, 'aria-disabled', mainButton.disabled ? 'true' : 'false');
    }

    function syncStickyPrice(variant) {
      if (!variant) return;

      var pricing = window.dwMemberPricing || {};
      var mapNode = product.querySelector('[data-variant-rrp-json]');
      var rrp = Number(variant.compare_at_price || 0);
      if (mapNode) {
        try { rrp = Math.max(rrp, Number(JSON.parse(mapNode.textContent)[String(variant.id)] || 0)); } catch (error) {}
      }
      var productSoldOut = product.getAttribute('data-dw-product-available') === 'false';
      var displayPrice = productSoldOut ? Math.max(variant.price, rrp) : variant.price;
      if (productSoldOut) rrp = 0;
      var discount = rrp > variant.price ? (rrp - variant.price) * 100 / rrp : 0;
      var clearance = !productSoldOut && product.getAttribute('data-dw-clearance-product') === 'true';
      var hasMemberPrice = discount >= 2;
      var quietPrice = pricing.quietMemberPrices && pricing.mode === 'members' && !clearance && discount > 0 && discount < 2;
      var showPair = hasMemberPrice || quietPrice;
      if (stickyPrice) setText(stickyPrice, formatMoney(displayPrice));
      if (stickyCompare) setText(stickyCompare, formatMoney(rrp || variant.price));
      if (stickyCompareRow) stickyCompareRow.hidden = !showPair;
      if (stickyLabel) {
        stickyLabel.hidden = !showPair && !clearance;
        var labels = pricing.labels || {};
        setText(stickyLabel, clearance ? labels.clearance : quietPrice ? labels.quietMember : pricing.mode === 'open_sale' ? labels.sale : labels.member);
      }
      if (stickyPriceWrap) {
        stickyPriceWrap.classList.toggle('is-member-price', hasMemberPrice || clearance);
        stickyPriceWrap.toggleAttribute('data-dw-quiet-price', Boolean(quietPrice));
      }
    }

    function updateStickyVisibility() {
      if (!sticky) return;
      var shouldShow = window.innerWidth <= 768 && window.scrollY > 220 && !mainButtonVisible;
      sticky.classList.toggle('is-visible', shouldShow);
      setAttribute(sticky, 'aria-hidden', shouldShow ? 'false' : 'true');
      document.body.classList.toggle('dw-pdp-sticky-visible', shouldShow);
    }

    if (gallery && counter) {
      var galleryObserver = new MutationObserver(updateGalleryCounter);
      galleryObserver.observe(gallery, {
        attributes: true,
        attributeFilter: ['class'],
        subtree: true
      });
      updateGalleryCounter();
    }

    if (galleryPrevious) {
      galleryPrevious.addEventListener('click', function () {
        moveGallery(-1);
      });
    }

    if (galleryNext) {
      galleryNext.addEventListener('click', function () {
        moveGallery(1);
      });
    }

    if (mainButton && sticky) {
      var buttonObserver = new IntersectionObserver(function (entries) {
        mainButtonVisible = entries[0].isIntersecting;
        updateStickyVisibility();
      }, { threshold: 0.1 });
      buttonObserver.observe(mainButton);

      var stateObserver = new MutationObserver(syncStickyButton);
      stateObserver.observe(mainButton, {
        attributes: true,
        attributeFilter: ['disabled', 'class'],
        childList: true,
        subtree: true
      });

      stickyButton.addEventListener('click', function () {
        if (mainButton.disabled) {
          var firstOption = product.querySelector('.variant-wrapper');
          if (firstOption) firstOption.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        mainButton.click();
      });

      window.addEventListener('scroll', updateStickyVisibility, { passive: true });
      window.addEventListener('resize', updateStickyVisibility);
      syncStickyButton();
      updateStickyVisibility();
    }

    product.addEventListener('variantChange', function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;

      syncStickyPrice(variant);

      window.setTimeout(function () {
        syncStickyButton();
        updateGalleryCounter();
      }, 0);
    });
  }

  function installGalleryVideoPlayback() {
    var prototype = window.theme && theme.Photoswipe && theme.Photoswipe.prototype;
    if (!prototype || prototype.dwVideoPlaybackReady) return;
    prototype.dwVideoPlaybackReady = true;

    var style = document.createElement('style');
    style.textContent =
      '.dw-zoom-video{position:absolute;inset:24px 54px 140px;z-index:2;display:flex;align-items:center;justify-content:center;background:#101820;cursor:default}' +
      '.pswp.dw-zoom-has-video .pswp__container{visibility:hidden}' +
      '.pswp.dw-zoom-has-video .pswp__ui{z-index:3}' +
      '.pswp.dw-zoom-has-video .pswp__ui .btn{background:#fff;color:#142939;border-color:#142939}' +
      '.dw-zoom-video video{display:block;width:100%;height:auto;max-height:100%;object-fit:contain;background:#101820}' +
      '.dw-zoom-video iframe{display:block;width:100%;height:100%;border:0}' +
      '.dw-zoom-video__play{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);min-height:48px;padding:14px 24px;border:0;border-radius:4px;background:#ffdd00;color:#142939;font:700 16px/1.2 system-ui;cursor:pointer}' +
      '.dw-zoom-video__play[hidden]{display:none}' +
      '.dw-zoom-video__play:focus-visible{outline:3px solid white;outline-offset:4px}' +
      '@media(max-width:768px){.dw-zoom-video{inset:20px 12px 140px}}';
    document.head.appendChild(style);

    function externalVideoSource(slide) {
      var external = slide.querySelector('[data-video-id], iframe[src*="youtube"], iframe[src*="vimeo"]');
      if (!external) return null;
      var id = external.getAttribute('data-video-id');
      var type = external.getAttribute('data-video-type');
      var href = external.getAttribute('href') || external.getAttribute('src') || '';
      if (id && (type === 'youtube' || /youtube\.com|youtu\.be/.test(href))) {
        return 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?autoplay=0&controls=1&playsinline=1&rel=0';
      }
      if (id && (type === 'vimeo' || /vimeo\.com/.test(href))) {
        return 'https://player.vimeo.com/video/' + encodeURIComponent(id) + '?autoplay=0&controls=1';
      }
      if (external.tagName !== 'IFRAME') return null;
      try {
        var url = new URL(href, location.origin);
        if (!/(^|\.)(youtube\.com|youtube-nocookie\.com|vimeo\.com)$/.test(url.hostname)) return null;
        url.searchParams.set('autoplay', '0');
        url.searchParams.set('controls', '1');
        return url.href;
      } catch (error) {
        return null;
      }
    }

    var initGallery = prototype.initGallery;
    prototype.initGallery = function (items, index, library) {
      initGallery.call(this, items, index, library);
      var gallery = this.gallery;
      var container = this.container;
      var root = document.querySelector('.pswp');
      var wrap = root && root.querySelector('.pswp__scroll-wrap');
      var overlay;
      var player;
      if (!gallery || !wrap) return;

      function clearPlayer() {
        root.classList.remove('dw-zoom-has-video');
        if (player && player.tagName === 'VIDEO') {
          player.pause();
          player.removeAttribute('src');
          player.querySelectorAll('source').forEach(function (source) {
            source.removeAttribute('src');
          });
          player.load();
        }
        if (overlay) overlay.remove();
        overlay = null;
        player = null;
      }

      function renderPlayer() {
        clearPlayer();
        var item = items[gallery.getCurrentIndex()];
        var slide = item && item.el && item.el.closest('.product-main-slide');
        if (!slide) return;
        var video = slide.querySelector('video');
        var externalSource = video ? null : externalVideoSource(slide);
        if (!video && !externalSource) return;

        container.querySelectorAll('video').forEach(function (inlineVideo) {
          inlineVideo.pause();
        });
        root.classList.add('dw-zoom-has-video');
        overlay = document.createElement('div');
        overlay.className = 'dw-zoom-video';
        overlay.setAttribute('aria-label', (item.el.alt || 'Product') + ' video');
        ['pointerdown', 'mousedown', 'touchstart', 'click'].forEach(function (name) {
          overlay.addEventListener(name, function (event) { event.stopPropagation(); });
        });

        if (video) {
          player = video.cloneNode(true);
          player.removeAttribute('id');
          player.removeAttribute('class');
          player.removeAttribute('style');
          player.removeAttribute('hidden');
          player.removeAttribute('autoplay');
          player.controls = true;
          player.playsInline = true;
          player.preload = 'metadata';
          player.muted = false;
          player.removeAttribute('muted');
          player.poster = item.src || item.msrc || video.poster;
          player.setAttribute('aria-label', (item.el.alt || 'Product') + ' video');
          player.querySelectorAll('source[data-src]').forEach(function (source) {
            source.src = source.getAttribute('data-src');
          });
          player.addEventListener('keydown', function (event) {
            if (event.key !== 'Escape') event.stopPropagation();
          });
          overlay.appendChild(player);
          var playButton = document.createElement('button');
          playButton.type = 'button';
          playButton.className = 'dw-zoom-video__play';
          playButton.textContent = 'Play video';
          playButton.addEventListener('click', function () {
            var promise = player.play();
            if (promise && promise.catch) promise.catch(function () { playButton.hidden = false; });
          });
          player.addEventListener('play', function () { playButton.hidden = true; });
          player.addEventListener('pause', function () { playButton.hidden = false; });
          player.addEventListener('ended', function () { playButton.hidden = false; });
          overlay.appendChild(playButton);
        } else {
          player = document.createElement('iframe');
          player.src = externalSource;
          player.title = (item.el.alt || 'Product') + ' video';
          player.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
          player.allowFullscreen = true;
          overlay.appendChild(player);
        }
        wrap.appendChild(overlay);
      }

      gallery.listen('beforeChange', clearPlayer);
      gallery.listen('afterChange', renderPlayer);
      gallery.listen('close', clearPlayer);
      gallery.listen('destroy', clearPlayer);
      renderPlayer();
    };
  }

  function init() {
    installGalleryVideoPlayback();
    document.body.classList.toggle('dw-shopify-preview', !!document.getElementById('PBarNextFrame'));
    document.querySelectorAll('[data-dw-pdp-cro]').forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

}());
